function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".poster-presenter-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "poster-presenter-1",
  d: "M60,1.93H31.84a5.91,5.91,0,0,0-5.91,5.91V21.72L30.54,24l2.3-4.6a5.64,5.64,0,0,1,10.09,5.05l-4.1,8.2a8.68,8.68,0,0,1-.3,3.24h2.71L34.1,55.52a1.88,1.88,0,1,0,3.53,1.29L45.24,35.9h1.32l7.68,20.92a1.88,1.88,0,0,0,3.53-1.3L50.56,35.9H60A5.91,5.91,0,0,0,65.94,30V7.84A5.9,5.9,0,0,0,60,1.93ZM56,27.84H47.57a1.88,1.88,0,0,1,0-3.76H56a1.88,1.88,0,0,1,0,3.76Zm0-7H47.57a1.88,1.88,0,0,1,0-3.76H56a1.88,1.88,0,1,1,0,3.76Zm0-7H35.87a1.88,1.88,0,1,1,0-3.76H56a1.88,1.88,0,1,1,0,3.76Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "poster-presenter-1",
  d: "M34.85,35.09a4.93,4.93,0,0,0,0-3l4.66-9.33a1.88,1.88,0,0,0-3.36-1.68l-4,8-8.9-4.43c-2.71-1.35-4.65-2.55-7.94-2.55H13.71a8.17,8.17,0,0,0,6.36-3,8.09,8.09,0,0,0,1.83-5.15,8.19,8.19,0,1,0-8.19,8.19,11.95,11.95,0,0,0-12,12v6a5.92,5.92,0,0,0,4,5.6V56.17a1.88,1.88,0,0,0,1.88,1.88H19.76a1.88,1.88,0,0,0,1.88-1.88V35l6,3a5.15,5.15,0,0,0,7.18-2.94v0Z"
});

var SvgPresenter = function SvgPresenter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 69.59 60.09",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPresenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/presenter.32c666d2.svg";
export { ForwardRef as ReactComponent };